import React, { useEffect, useState } from 'react'
import {
  FormDashboardLabel as Label,
  Checkbox,
  RequiredLabel,
} from '../../../components'
import { useDispatch, useSelector } from 'react-redux'
import debounce from 'lodash.debounce'
import { updateForm } from '../../../features/blog-form/slice'
import { useInternationalization } from '../../../features/i18n'

const SidebarCategories = () => {
  const dispatch = useDispatch()
  const {translate, language} = useInternationalization()
  const categories = useSelector(state => state.system.categories_blog)
  const [categoryOptions, setCategoryOptions] = useState([])
  const form = useSelector(state => state.blogForm.data)
  const [showCheckboxes, setShowCheckboxes] = useState(true)
  const [defaultChecked, setDefaultChecked] = useState([])

  useEffect(() => {
    if(form.categories && form.categories.length > 0){
      setDefaultChecked(form.categories)
    }
    //eslint-disable-next-line
  }, [form])

  // Re-render categories options every time default checked values changed
  useEffect(() => {
    setShowCheckboxes(false)

    setTimeout(() => {
      setShowCheckboxes(true)
    }, 250)
  }, [defaultChecked])

  useEffect(() => {
    if(categories && categories.length > 0){
      let options = categories.map(c => {
        return {
          id: c.id,
          title: c.name[language.name]
        }
      })
      setCategoryOptions(options)
    }
  }, [categories, setCategoryOptions, language])

  const handleInput = debounce((e) => {
    if(e.target && e.target !== null){
      const key = e.target.name
      const value = e.target.value
      dispatch(updateForm({key, value}))
    }
  }, 250)

  const onCategoryCheckboxChange = (e) => {
    const lastCategories = form.categories ? [...form.categories] : []

    if (e.target.checked) {
      handleInput({
        target: {
          name: 'categories',
          value: [
            ...lastCategories,
            parseInt(e.target.value)
          ]
        }
      })
    } else {
      handleInput({
        target: {
          name: 'categories',
          value: lastCategories.filter(v => v !== parseInt(e.target.value))
        }
      })
    }
  }

  return (
    <>
      <Label>{translate('SEARCH', 'categories')} <RequiredLabel /></Label>
      {
        showCheckboxes &&
        <div className="pt-3">
          <div className="grid grid-cols-2 gap-1 lg:grid-cols-1">
            {categoryOptions.map((cat) => (
              <div key={cat.id}>
                <Checkbox
                  className="mb-2"
                  label={cat.title}
                  value={cat.id}
                  defaultChecked={defaultChecked && defaultChecked.includes(cat.id)}
                  onChange={onCategoryCheckboxChange}
                />
              </div>
            ))}
          </div>
        </div>
      }
    </>
  )
}

export default SidebarCategories
